import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Slider } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";
import "./VideoAiNew.css";
import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentVideoAi from "../Gallery/ContentVideoAi";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import InfoIcon from '@mui/icons-material/Info';
import { VideoAiExamplePrompt } from "./VideoAiExamplePrompt";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ImageIcon from "@mui/icons-material/Image";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
const MODES = [
    {
        key: "Text to Video (T2V)",
        label: "T2V", icon: <EditNoteIcon />,
        desc: "Text to Video (T2V): Create a video from a text prompt",
        title: "Text to Video (T2V): Create a video from a text prompt"
    },
    {
        key: "Image to Video (I2V)",
        label: "I2V", icon: <ImageIcon />,
        desc: "Image to Video (I2V): Animate a single uploaded image.",
        title: "Image to Video (I2V): Animate a single uploaded image"
    },
    {
        key: "Frame Interpolation",
        label: "Frames", icon: <SwapHorizIcon />,
        desc: "Frame Interpolation: Upload both a start frame and an end frame to generate a smooth transition.",
        title: "Frame Interpolation: Upload both a start frame and an end frame to generate a smooth transition."
    },
    // { key: "Audio-Driven (S2V)", label: "S2V", icon: "🎵", desc: "Generate video synchronized with audio." },
];


const MODELS = [
    { value: "veo-3.1", label: "Veo 3.1", desc: "Supports 4s, 6s, 8s", info: "High-fidelity, cinematic generation optimized for high visual realism and precise prompt adherence in standard short clips." },
    { value: "kling", label: "Kling V3.0 Pro", desc: "Supports 3s to 15s", info: "Professional-grade video generation optimized for longer, complex motion sequences up to 15 seconds." },
    { value: "veo-3.1-lite", label: "Veo 3.1 Lite", desc: "Supports 4s, 6s, 8s", info: "A balanced, resource-efficient option that delivers high quality visual output while consuming fewer processing credits." },
    { value: "seedance", label: "Seedance 2.5", desc: "Supports 4s to 15s", info: "Highly flexible motion generation suited for fluid action, multi-frame continuity, and extended clip lengths up to 15 seconds." },
    { value: "veo-3.1-fast", label: "Veo 3.1 Fast", desc: "Supports 4s, 6s, 8s", info: "Optimized for rapid rendering speed, offering quick concept iteration and rapid previews without compromising core composition." },
    { value: "wan-2.7", label: "Wan 2.7", desc: "Supports 2s to 10s", info: "Quick-burst generation ideal for short, highly dynamic motion snippets and precise timing adjustments up to 10 seconds." },
    { value: "wan-3.0", label: "Wan 3.0", desc: "Supports 2s to 30s", info: "Advanced temporal continuity model designed for extended, seamless video generation lasting up to 30 seconds." },
];

const ASPECTS = [
    { value: "16:9", label: "Widescreen", icon: "🖥️" },
    { value: "9:16", label: "Vertical", icon: "📱" }
];

const RESOLUTIONS = [
    { value: "480p", label: "480p", icon: "SD" },
    { value: "720p", label: "720p", icon: "HD" },
    { value: "1080p", label: "1080p", icon: "FHD" },
    { value: "2K", label: "2K", icon: "2K" },
    { value: "4K", label: "4K", icon: "4K" }
];

const MODEL_RESOLUTIONS = {
    "wan-2.7": ["720p", "1080p"],
    "wan-3.0": ["480p", "720p", "1080p"],
    "kling": ["720p"],
    "seedance": ["480p", "1080p", "2k", "4K"],
    "veo-3.1": ["720p", "1080p", "4K"],
    "veo-3.1-fast": ["720p", "1080p", "4K"],
    "veo-3.1-lite": ["720p", "1080p"]
};

const CREDIT_RATE_MAP = {
    "veo-3.1-lite": {
        "720p": 10,
        "1080p": 14
    },

    "kling": {
        "720p": 28,
        "1080p": 48
    },

    "veo-3.1-fast": {
        "720p": 18,
        "1080p": 20,
        "4K": 50
    },

    "veo-3.1": {
        "720p": 68,
        "1080p": 68,
        "4K": 100
    },

    "seedance": {
        "480p": 12,
        "720p": 26,
        "1080p": 64,
        "4K": 130
    },

    "wan-2.7": {
        "720p": 24,
        "1080p": 48
    },

    "wan-3.0": {
        "480p": 12,
        "720p": 24,
        "1080p": 48
    }
};

export default function VideoAiNew() {
    const [mode, setMode] = useState(MODES[0].key);
    const [prompt, setPrompt] = useState("");
    const [textRenderingEnabled, setTextRenderingEnabled] = useState(false);
    const [textRendering, setTextRendering] = useState("");
    const [modelType, setModelType] = useState("");
    const [duration, setDuration] = useState("");
    const [aspectRatio, setAspectRatio] = useState("");
    const [resolution, setResolution] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [generatedVideo, setGeneratedVideo] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [suggestedPrompt, setSuggestedPrompt] = useState("");

    // File states
    const [startImage, setStartImage] = useState(null);
    const [startPreview, setStartPreview] = useState(null);
    const [endImage, setEndImage] = useState(null);
    const [endPreview, setEndPreview] = useState(null);
    const [audioFile, setAudioFile] = useState(null);
    const [audioName, setAudioName] = useState("");

    const [selectedModelInfo, setSelectedModelInfo] = useState(null);

    const startRef = useRef(null);
    const endRef = useRef(null);
    const audioRef = useRef(null);

    const videoRefs = useRef([]);

    const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
    const navigate = useNavigate();

    const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

    const totalCredits = duration && modelType && resolution
        ? Math.round((CREDIT_RATE_MAP[modelType]?.[resolution] || 0) * Number(duration) * 1)
        : 0;
    const creditCostUSD = totalCredits * 0.012;

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {
        setSuggestedPrompt(VideoAiExamplePrompt[Math.floor(Math.random() * VideoAiExamplePrompt.length)]);

        const intervalId = setInterval(() => {
            setSuggestedPrompt(VideoAiExamplePrompt[Math.floor(Math.random() * VideoAiExamplePrompt.length)]);
        }, 10000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const checkUnviewedAndActive = async () => {
            // Check for unviewed videos first
            const unviewedStr = localStorage.getItem("unviewed_video_ai");
            if (unviewedStr) {
                try {
                    const unviewed = JSON.parse(unviewedStr);
                    if (unviewed.length > 0) {
                        const videoData = unviewed[unviewed.length - 1];
                        setGeneratedVideo(videoData);
                        setIsLoading(false);

                        // Clean up localStorage
                        localStorage.removeItem("unviewed_video_ai");
                        const activeStr = localStorage.getItem("active_video_ai");
                        if (activeStr) {
                            try {
                                const active = JSON.parse(activeStr);
                                if (active.transactionId === videoData.transactionId) {
                                    localStorage.removeItem("active_video_ai");
                                }
                            } catch (e) { }
                        }

                        // Mark viewed
                        fetch("https://backend.whalesai.com/api/v1/video-ai/mark-viewed", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `Bearer ${localStorage.getItem("aiUser")}`
                            },
                            body: JSON.stringify({ transactionId: videoData.transactionId })
                        }).catch(err => console.error("Error marking viewed:", err));

                        return;
                    }
                } catch (e) {
                    console.error("Error parsing unviewed data:", e);
                }
            }

            // If no unviewed, check active status
            const storedStr = localStorage.getItem("active_video_ai");
            console.log("Checking active-status, found storedStr:", storedStr);

            if (!storedStr) {
                console.log("No active_video_ai in localStorage, skipping active-status check.");
                return;
            }

            try {
                const stored = JSON.parse(storedStr);
                console.log("Fetching active-status from API...");
                const res = await fetch("https://backend.whalesai.com/api/v1/video-ai/active-status", {
                    method: "GET",
                    headers: { authorization: `Bearer ${localStorage.getItem("aiUser")}` }
                });
                const result = await res.json();

                if (result.success && result.isGenerating && result.transactionId === stored.transactionId) {
                    setIsLoading(true);
                } else if (result.success && result.status === "completed" && result.data && result.transactionId === stored.transactionId) {
                    // It finished while the phone was locked/inactive!
                    setIsLoading(false);
                    setGeneratedVideo({
                        status: "completed",
                        transactionId: result.transactionId,
                        videoUrl: result.data.videoUrl,
                        data: result.data
                    });
                    localStorage.removeItem("active_video_ai");

                    fetch("https://backend.whalesai.com/api/v1/video-ai/mark-viewed", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `Bearer ${localStorage.getItem("aiUser")}`
                        },
                        body: JSON.stringify({ transactionId: result.transactionId })
                    }).catch(err => console.error("Error marking viewed:", err));
                } else if (result.success && !result.isGenerating) {
                    setIsLoading(false);
                    localStorage.removeItem("active_video_ai");
                }
            } catch (error) {
                console.error("Error checking active status:", error);
            }
        };

        // Check immediately
        checkUnviewedAndActive();
        const handleWakeUp = () => {
            if (document.visibilityState === 'visible' || !document.hidden) {
                checkUnviewedAndActive();
            }
        };
        document.addEventListener("visibilitychange", handleWakeUp);
        window.addEventListener("focus", handleWakeUp);
        window.addEventListener("pageshow", handleWakeUp);

        return () => {
            document.removeEventListener("visibilitychange", handleWakeUp);
            window.removeEventListener("focus", handleWakeUp);
            window.removeEventListener("pageshow", handleWakeUp);
        };
    }, []);

    useEffect(() => {
        const handleBackendTask = (e) => {
            const data = e.detail;
            if (data.type === 'video_ai_completed' && data.status === 'completed' && data.videoUrl) {
                setGeneratedVideo(data);
                setIsLoading(false);

                const storedStr = localStorage.getItem("active_video_ai");
                if (storedStr) {
                    try {
                        const stored = JSON.parse(storedStr);
                        if (stored.transactionId === data.transactionId) {
                            localStorage.removeItem("active_video_ai");
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }

                // Mark viewed
                fetch("https://backend.whalesai.com/api/v1/video-ai/mark-viewed", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`
                    },
                    body: JSON.stringify({ transactionId: data.transactionId })
                }).catch(err => console.error("Error marking viewed:", err));

                // Clear unviewed since we just handled it in the active listener
                localStorage.removeItem("unviewed_video_ai");
            }
        };

        const handleBackendTaskFailed = (e) => {
            const data = e.detail;
            if (data.type === 'video_ai_failed' && data.status === 'failed') {
                setIsLoading(false);
                swal({
                    text: data.message || "AI Video generation failed.",
                    icon: "error",
                    buttons: "Ok",
                    className: "modal_class_success",
                });

                const storedStr = localStorage.getItem("active_video_ai");
                if (storedStr) {
                    try {
                        const stored = JSON.parse(storedStr);
                        if (stored.transactionId === data.transactionId) {
                            localStorage.removeItem("active_video_ai");
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        };

        window.addEventListener('backend_task_completed', handleBackendTask);
        window.addEventListener('backend_task_failed', handleBackendTaskFailed);

        return () => {
            window.removeEventListener('backend_task_completed', handleBackendTask);
            window.removeEventListener('backend_task_failed', handleBackendTaskFailed);
        };
    }, []);



    const handleFileChange = (e, setFile, setPreview, isImage = true) => {
        const file = e.target.files[0];
        if (!file) return;
        setFile(file);
        if (isImage) {
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        } else {
            setAudioName(file.name);
        }
    };

    const handleRemoveFile = (e, setFile, setPreview, ref) => {
        e.stopPropagation();
        setFile(null);
        if (setPreview) setPreview(null);
        if (ref?.current) ref.current.value = "";
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e, setFile, setPreview, isImage = true) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFileChange({ target: { files: e.dataTransfer.files } }, setFile, setPreview, isImage);
        }
    };

    const handleGenerate = async () => {
        if (AIuser.credits < totalCredits) {
            swal({ text: "You don't have enough credits! Please buy credits to continue.", icon: "error", buttons: "Buy", className: "modal_class_success" })
                .then((v) => { if (v) navigate("/purchase"); });
            return;
        }
        if (!prompt.trim()) { swal({ text: "Please enter a prompt.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (!modelType) { swal({ text: "Please select a model.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (!duration) { swal({ text: "Please select a duration.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (!resolution) { swal({ text: "Please select a resolution.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (!aspectRatio) { swal({ text: "Please select an aspect ratio.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (mode === "Image to Video (I2V)" && !startImage) { swal({ text: "Please upload a starting image.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (mode === "Frame Interpolation" && (!startImage || !endImage)) { swal({ text: "Please upload both start and end frames.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }
        if (mode === "Audio-Driven (S2V)" && !audioFile) { swal({ text: "Please upload an audio file.", icon: "warning", buttons: "Ok", className: "modal_class_success" }); return; }

        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append("credit", totalCredits);
            formData.append("mode", mode);
            formData.append("prompt", prompt.trim());
            formData.append("textRendering", textRenderingEnabled ? textRendering : "");
            formData.append("model", modelType);
            formData.append("duration", duration);
            formData.append("resolution", resolution);
            formData.append("aspectRatio", aspectRatio);
            if (mode === "Image to Video (I2V)") {
                formData.append("startImage", startImage);
            }

            if (mode === "Frame Interpolation") {
                formData.append("startFrame", startImage);
                formData.append("endFrame", endImage);
            }

            if (audioFile) formData.append("audio", audioFile);

            const response = await fetch("https://backend.whalesai.com/api/v1/video-ai/generate", {
                method: "POST",
                headers: { authorization: `Bearer ${localStorage.getItem("aiUser")}` },
                body: formData,
            });
            const result = await response.json();
            if (!response.ok || !result.success) throw new Error(result.message || "Failed to generate video");

            setUserRefetch(!userRefetch)

            const txId = result.transactionId || result.data?.transactionId;
            if (txId) {
                localStorage.setItem("active_video_ai", JSON.stringify({
                    transactionId: txId,
                    aiType: "video-ai"
                }));
            }
        } catch (error) {
            console.error("Error generating video:", error);
            setIsLoading(false);
            swal({ text: error.message || "Something went wrong! Please try again.", icon: "error", buttons: "Ok", className: "modal_class_success" });
        }
    };

    const downloadVideo = async () => {
        const urlToDownload = typeof generatedVideo === 'string' ? generatedVideo : generatedVideo?.videoUrl;
        if (!urlToDownload) return;
        setDownloading(true);
        try {
            const response = await fetch(urlToDownload);
            if (!response.ok) throw new Error("Network response was not ok");
            const blob = await response.blob();
            saveAs(blob, "GeneratedVideo.mp4");
        } catch (error) {
            console.error("Download failed:", error);
            swal({
                text: "Failed to download the video.",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
        }
        setDownloading(false);
    };

    const handleClear = () => {
        setPrompt(""); setTextRenderingEnabled(false); setTextRendering("");
        setModelType(""); setDuration(""); setAspectRatio(""); setResolution("");
        setStartImage(null); setStartPreview(null); setEndImage(null); setEndPreview(null);
        setAudioFile(null); setAudioName(""); setGeneratedVideo(null);
        [startRef, endRef, audioRef].forEach(r => { if (r.current) r.current.value = ""; });
    };

    const modeObj = MODES.find(m => m.key === mode);
    const isFormValid = prompt.trim() && modelType && duration && aspectRatio && resolution;

    const renderUploadArea = (label, accept, fileState, previewState, setFile, setPreview, ref, isImage = true) => (
        <div className="mb-3">
            <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                {label} <span className="text-danger">*</span>
            </label>
            <div className={`video-ai-upload-area ${(isImage ? previewState : fileState) ? "has-file" : ""}`}
                onClick={() => ref.current?.click()}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, setFile, setPreview, isImage)}>
                <input type="file" ref={ref} accept={accept} onChange={(e) => handleFileChange(e, setFile, setPreview, isImage)} style={{ display: "none" }} />
                {isImage && previewState ? (
                    <>
                        <img src={previewState} alt="Preview" className="video-ai-preview-img" />
                        <button className="video-ai-remove-btn" onClick={(e) => handleRemoveFile(e, setFile, setPreview, ref)} title="Remove">✕</button>
                    </>
                ) : !isImage && fileState ? (
                    <>
                        <div className="video-ai-file-info">
                            <div className="video-ai-file-icon">🎵</div>
                            <div><div className="video-ai-file-name">{audioName}</div><div className="video-ai-file-size">{(fileState.size / 1024 / 1024).toFixed(2)} MB</div></div>
                        </div>
                        <button className="video-ai-remove-btn" onClick={(e) => { handleRemoveFile(e, setFile, null, ref); setAudioName(""); }} title="Remove">✕</button>
                    </>
                ) : (
                    <>
                        <div className="video-ai-upload-icon">{isImage ? "📷" : "🎵"}</div>
                        <div className="video-ai-upload-text">Drag & drop or <span>browse</span></div>
                        <div className="video-ai-upload-hint">{isImage ? "Supports JPG, PNG, WEBP" : "Supports MP3, WAV"}</div>
                    </>
                )}
            </div>
        </div>
    );

    const step2LabelText = (mode) => {
        switch (mode) {
            case "Image to Video (I2V)":
                return "Upload Image & Enter Prompt";
            case "Frame Interpolation":
                return "Upload Frames & Enter Prompt";
            case "Audio-Driven (S2V)":
                return "Upload Audio & Enter Prompt";
            default:
                return "Enter Prompt";
        }
    }
    return (
        <Fragment>
            <PageHeading
                title="VIDEO AI"
                description="Generate stunning AI-powered videos."
                onInfoClick={() => setShowPdfModal(true)}
                infoTooltip="See sample video"
            />
            <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="Sample">
                <ContentVideoAi />
            </SamplePdfModal>
            {selectedModelInfo && (
                <div
                    className="video-ai-info-modal-overlay"
                    onClick={() => setSelectedModelInfo(null)}
                >
                    <div
                        className="video-ai-info-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="video-ai-info-modal-header">
                            <h5>{selectedModelInfo.label}</h5>

                            <button
                                type="button"
                                className="video-ai-info-close-btn"
                                onClick={() => setSelectedModelInfo(null)}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="video-ai-info-modal-body">
                            <p>{selectedModelInfo.info}</p>
                        </div>
                    </div>
                </div>
            )}

            <div className="container pb-5" style={{ maxWidth: "872px", paddingInline: "12px", marginInline: "auto" }}>
                <div className="container py-5">
                    {/* Credits */}
                    <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                        <div>
                            <div>
                                <button className="credits-button">CREDITS : {creditToLocalString}</button>
                                <button className="buy-credits-button" onClick={() => navigate("/purchase")}>BUY CREDITS</button>
                                <button onClick={() => navigate("/usage")} className="money-exchange-button">
                                    <img src={moneyExchangeIcon} alt="usage" />
                                </button>
                            </div>
                            <p style={{ fontSize: "8px" }} className="text-white mt-2 creditText text-center">
                                {totalCredits > 0 ? `${totalCredits} Credits (USD ${creditCostUSD.toFixed(2)} based on Credits Package 3)` : "Select model & duration to see cost"}
                            </p>
                        </div>
                    </div>

                    {/* Step 1 – Mode */}
                    <div className="mb-4 mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="video-ai-step-label mb-0">Step 1</div>
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => window.location.reload()}
                            >
                                Clear all
                            </Button>
                        </div>
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>Select Generation Mode</label>
                        <div className="video-ai-mode-tabs">
                            {MODES.map((m) => (
                                <button key={m.key} className={`video-ai-mode-tab ${mode === m.key ? "active" : ""}`} onClick={() => setMode(m.key)} title={m.title}>
                                    <span className="mode-tab-icon">{m.icon}</span>
                                    <span className="mode-tab-label">{m.label}</span>
                                </button>
                            ))}
                        </div>
                        <p className="video-ai-mode-description">{modeObj?.desc}</p>
                    </div>

                    {/* Step 2 – Upload & Prompt */}
                    <div className="mb-4">
                        <div className="video-ai-step-label">Step 2</div>
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                            {step2LabelText(mode)}
                        </label>

                        {mode === "Image to Video (I2V)" && renderUploadArea("Upload Image", "image/jpeg,image/png,image/webp", startImage, startPreview, setStartImage, setStartPreview, startRef)}

                        {mode === "Frame Interpolation" && (
                            <div className="video-ai-upload-row">
                                <div>{renderUploadArea("Start Frame", "image/jpeg,image/png,image/webp", startImage, startPreview, setStartImage, setStartPreview, startRef)}</div>
                                <div>{renderUploadArea("End Frame", "image/jpeg,image/png,image/webp", endImage, endPreview, setEndImage, setEndPreview, endRef)}</div>
                            </div>
                        )}

                        {mode === "Audio-Driven (S2V)" && renderUploadArea("Upload Audio", "audio/mpeg,audio/wav", audioFile, null, setAudioFile, null, audioRef, false)}

                        <div className="mb-3">
                            <label className="text-white mb-2" style={{ fontSize: "14px" }}>Prompt <span className="text-danger">*</span></label>
                            <textarea className="video-ai-prompt-textarea" value={prompt} onChange={(e) => setPrompt(e.target.value)}
                                placeholder="Describe the scene, motion, camera movement, and visual style you want to generate." />
                            <div className="mt-2" style={{ fontSize: "13px", color: "#a0a0a0" }}>
                                Suggested:{" "}
                                <span
                                    style={{ color: "#4da8da", cursor: "pointer" }}
                                    onClick={() => setPrompt(suggestedPrompt)}
                                >
                                    {suggestedPrompt}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Step 3 – Model */}
                    <div className="mb-4">
                        <div className="video-ai-step-label">Step 3</div>
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>Select AI Model <span className="text-danger">*</span> <span>(Highest price to lower price)</span> </label>
                        <div className="video-ai-model-grid">
                            {/* {MODELS.map((m) => {
                                const isDisabled = false;
                                return ( */}
                            {MODELS
                                .filter((m) => !(
                                    (mode === "Image to Video (I2V)" && m.value === "veo-3.1-lite") ||
                                    (mode === "Frame Interpolation" && m.value === "wan-3.0")
                                ))
                                .map((m) => {
                                    const isDisabled = false;
                            return (
                            <div
                                key={m.value}
                                className={`video-ai-model-card ${modelType === m.value ? "selected" : ""} ${isDisabled ? "disabled" : ""}`}
                                style={
                                    isDisabled
                                        ? {
                                            opacity: 0.5,
                                            cursor: "not-allowed",
                                            pointerEvents: "none",
                                        }
                                        : {}
                                }
                                onClick={() => {
                                    if (!isDisabled) {
                                        setModelType(m.value);

                                        const validRes = MODEL_RESOLUTIONS[m.value] || [];

                                        if (
                                            validRes.length > 0 &&
                                            (!resolution || !validRes.includes(resolution))
                                        ) {
                                            setResolution(validRes[0]);
                                        }

                                        // Set the highest available duration for the selected model
                                        if (m.value === "wan-2.7") {
                                            setDuration("10");
                                        } else if (m.value === "wan-3.0") {
                                            setDuration("30");
                                        } else if (m.value === "seedance") {
                                            setDuration("15");
                                        } else if (m.value === "kling") {
                                            setDuration("15");
                                        } else if (m.value.startsWith("veo")) {
                                            setDuration("8");
                                        }
                                    }
                                }}
                            >
                                <div className="model-name-row">
                                    <div className="model-name">{m.label}</div>

                                    <button
                                        type="button"
                                        className="model-info-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedModelInfo(m);
                                        }}
                                        aria-label={`More information about ${m.label}`}
                                        title={`More information about ${m.label}`}
                                    >
                                        <InfoIcon />
                                    </button>
                                </div>

                                <div className="model-desc">{m.desc}</div>
                            </div>
                            );
                                })}
                        </div>
                    </div>

                    {/* Step 4 – Settings */}
                    <div className="mb-4">
                        <div className="video-ai-step-label">Step 4</div>
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>Configure Video Settings</label>

                        <div className="mb-3">
                            <label className="text-white mb-2" style={{ fontSize: "13px" }}>Duration (Seconds) <span className="text-danger">*</span></label>
                            <div className="px-0 py-2">
                                {!modelType ? (
                                    <div className="text-white-50 pl-0 " style={{ fontSize: "12px" }}>Please select an AI Model first to configure duration.</div>
                                ) : (
                                    <Slider
                                        value={Number(duration) || (modelType.startsWith("veo") ? 4 : 5)}
                                        onChange={(e, val) => setDuration(String(val))}
                                        step={modelType.startsWith("veo") ? null : 1}
                                        marks={modelType.startsWith("veo") ? [
                                            { value: 4, label: <span className="text-white">4s</span> },
                                            { value: 6, label: <span className="text-white">6s</span> },
                                            { value: 8, label: <span className="text-white">8s</span> }
                                        ] : [
                                            { value: (modelType.startsWith("wan") ? 2 : modelType === "seedance" ? 4 : 3), label: <span className="text-white">{modelType.startsWith("wan") ? 2 : modelType === "seedance" ? 4 : 3}s</span> },
                                            { value: 10, label: <span className="text-white">10s</span> },
                                            ...(modelType === "wan-3.0" ? [{ value: 20, label: <span className="text-white">20s</span> }, { value: 30, label: <span className="text-white">30s</span> }] : modelType !== "wan-2.7" ? [{ value: 15, label: <span className="text-white">15s</span> }] : [])
                                        ]}
                                        min={modelType.startsWith("veo") ? 4 : (modelType.startsWith("wan") ? 2 : modelType === "seedance" ? 4 : 3)}
                                        max={modelType.startsWith("veo") ? 8 : (modelType === "wan-2.7" ? 10 : modelType === "wan-3.0" ? 30 : 15)}
                                        valueLabelDisplay="auto"
                                        sx={{
                                            color: '#f0b90b',
                                            '& .MuiSlider-markLabel': { color: 'white' },
                                            '& .MuiSlider-valueLabel': { backgroundColor: '#f0b90b', color: 'black' }
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="text-white mb-2" style={{ fontSize: "13px" }}>Resolution <span className="text-danger">*</span></label>
                            <div className="video-ai-aspect-grid">
                                {!modelType ? (
                                    <div className="text-white-50" style={{ fontSize: "12px" }}>Please select an AI Model first to configure resolution.</div>
                                ) : (
                                    RESOLUTIONS.filter(r => (MODEL_RESOLUTIONS[modelType] || []).includes(r.value)).map((r) => (
                                        <div key={r.value} className={`video-ai-aspect-card ${resolution === r.value ? "selected" : ""}`} onClick={() => setResolution(r.value)}>
                                            <div className="aspect-icon">{r.icon}</div>
                                            <div className="aspect-label">{r.label}</div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="text-white mb-2" style={{ fontSize: "13px" }}>Aspect Ratio <span className="text-danger">*</span></label>
                            <div className="video-ai-aspect-grid">
                                {ASPECTS.map((a) => (
                                    <div key={a.value} className={`video-ai-aspect-card ${aspectRatio === a.value ? "selected" : ""}`} onClick={() => setAspectRatio(a.value)}>
                                        <div className="aspect-icon">{a.icon}</div>
                                        <div className="aspect-value">{a.value}</div>
                                        <div className="aspect-label">{a.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Cost Summary */}
                    <div className="video-ai-cost-summary">
                        <span className="video-ai-cost-label">Estimated Cost</span>
                        <span className="video-ai-cost-value">
                            {totalCredits > 0 ? totalCredits : "—"}<span> credits</span>
                            <p
                                className="video-ai-cost-value"
                                style={{ fontSize: "12px", color: "#a0a0a0", marginTop: "4px" }}
                            >USD {creditCostUSD.toFixed(2)} (As per package 3)</p>
                        </span>
                    </div>

                    {/* Generated Video */}
                    {generatedVideo && (
                        <div className="mt-5 d-flex flex-column align-items-center">
                            <h4 className="text-white mb-3">Generated Video</h4>
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "720px",
                                    marginBottom: "24px",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                }}
                            >
                                <video
                                    src={typeof generatedVideo === 'string' ? generatedVideo : generatedVideo.videoUrl}
                                    controls
                                    autoPlay
                                    muted
                                    style={{
                                        width: "100%",
                                        display: "block",
                                    }}
                                />
                            </div>
                            <Button
                                sx={{
                                    padding: '8px 30px',
                                    margin: '15px auto',
                                    display: 'flex',
                                    gap: '8px',
                                    background: '#2e7d32!important',
                                    color: 'white!important',
                                }}
                                variant="contained"
                                onClick={downloadVideo}
                                disabled={downloading}
                            >
                                <DownloadOutlined />
                                {downloading ? 'Downloading...' : 'Download'}
                            </Button>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="d-flex justify-content-center align-items-center mb-4">
                        <Button sx={{ padding: "8px 30px", marginRight: "10px", color: "#000", background: "#fff", "&:hover": { background: "#fff" }, "&:disabled": { background: "#fff" } }}
                            onClick={handleClear} disabled={isLoading} variant="contained">Clear</Button>
                        <Button sx={{ padding: "8px 30px", "&:disabled": { background: "gray" } }}
                            onClick={handleGenerate} className="generate-button text-white" disabled={!isFormValid || isLoading} variant="contained">
                            {isLoading ? "Processing..." : "Generate"}
                        </Button>
                    </div>

                    <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1 mb-3">
                        While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                    </div>

                    <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center mt-5 mb-3">
                        Transform Ideas into Videos with Our AI
                    </div>

                    {/* AI Video Examples */}

                    <div className="row g-4 mt-2 mb-4">
                        <div className="col-12 col-md-6">
                            <div className="video-ai-example-card">
                                <video
                                    ref={(el) => (videoRefs.current[0] = el)}
                                    src="https://backend.whalesai.com/public/hiwvideos/video-ai-sample.mp4"
                                    poster="/videoaic1.jpeg"
                                    controls
                                    muted
                                    loop
                                    playsInline
                                    preload="metadata"
                                    className="video-ai-example-video"
                                    onPlay={() => {
                                        videoRefs.current.forEach((video, index) => {
                                            if (video && index !== 0) {
                                                video.pause();
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="video-ai-example-card">
                                <video
                                    ref={(el) => (videoRefs.current[1] = el)}
                                    src="https://backend.whalesai.com/public/hiwvideos/video-ai-sample-2.mp4"
                                    poster="/videoaic2.jpeg"
                                    controls
                                    muted
                                    loop
                                    playsInline
                                    preload="metadata"
                                    className="video-ai-example-video"
                                    onPlay={() => {
                                        videoRefs.current.forEach((video, index) => {
                                            if (video && index !== 1) {
                                                video.pause();
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Progress */}
                    {isLoading && (
                        <div className="video-ai-progress-container d-flex flex-column align-items-center">
                            <div className="spinner-border text-light mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                    {isLoading && <p className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1 mb-3">The video generation process may take some time. Feel free to return later. Once your video is ready, it will be sent to your email, and you can also view it anytime on the Usage page.</p>}
                    {isLoading && <AiFactsDisplay />}
                </div>
            </div>
        </Fragment>
    );
}

